export interface QueryParamCredentials {
  username: string;
  password: string;
}

type QueryParamName = string | string[];

interface CredentialQueryParamNames {
  username: QueryParamName;
  password: QueryParamName;
}

const DefaultCredentialQueryParamNames: CredentialQueryParamNames = {
  username: 'username',
  password: 'password',
};

const decodeBase64Url = (value: string) => {
  try {
    const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
    const paddedBase64 = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');

    return atob(paddedBase64);
  } catch {
    return '';
  }
};

const getFirstQueryParamValue = (searchParams: URLSearchParams, name: QueryParamName) => {
  const names = Array.isArray(name) ? name : [name];

  for (const queryParamName of names) {
    const value = searchParams.get(queryParamName);

    if (value) {
      return value;
    }
  }

  return '';
};

export const getQueryParamCredentials = (
  searchParams: URLSearchParams,
  encodedCredentialsQueryParamName: QueryParamName,
  credentialQueryParamNames = DefaultCredentialQueryParamNames,
): QueryParamCredentials => {
  const encodedCredentials = getFirstQueryParamValue(
    searchParams,
    encodedCredentialsQueryParamName,
  );
  const credentialSearchParams = encodedCredentials
    ? new URLSearchParams(decodeBase64Url(encodedCredentials))
    : searchParams;

  return {
    username: getFirstQueryParamValue(credentialSearchParams, credentialQueryParamNames.username),
    password: getFirstQueryParamValue(credentialSearchParams, credentialQueryParamNames.password),
  };
};
